export const challengeRoutePath = '/challenge';
